<template> 
<div class="width-100">
        <div class="d-none row d-xl-flex d-xl-flex width-100">
            <div class="col-md-6 d-none d-md-flex align-items-center justify-content-start">
                <div class="d-flex bck-grey px-3 py-2">
                    <a href="https://www.facebook.com/Convergenzespa" class="facebook-link text-right" target="_blank">
                        <ficon :icon="['fab', 'facebook-f']" size="2x"></ficon>
                        
                    </a>
                    <a href="https://twitter.com/ConvergenzeSPA" class="twitter-link" target="_blank">
                        <ficon :icon="['fab', 'twitter']" size="2x"></ficon>
                    </a>
                    <a href="https://www.instagram.com/convergenze.it/" class="instagram-link" target="_blank">
                        <ficon :icon="['fab', 'instagram']" size="2x"></ficon>
                    </a>
                    
                    <a href="https://www.linkedin.com/company/convergenze---s.p.a." class="linkedin-link"
                        target="_blank">
                        <ficon :icon="['fab', 'linkedin-in']" size="2x"></ficon>
                    </a>
                    <a href="https://www.youtube.com/channel/UC0vUWxtZgfyrQMwi9FnEuyA" class="youtube-link"
                        target="_blank">
                        <ficon :icon="['fab', 'youtube']" size="2x"></ficon>
                    </a>
                </div>
            </div>
            <div class="col-md-4 d-none d-md-flex align-items-center justify-content-end">
                <div class="d-flex align-items-center text-white">
                    <h2>800 987 787 </h2>
                </div>
            </div>
            <div class="col-md-2 d-none d-md-flex align-items-center justify-content-start">            
                <router-link to="/" class="navbar-brand border-left">
                    &nbsp;&nbsp;<img src="../assets/images/logo.png" class="img-fluid" />
                </router-link>
            </div>
        </div>
        <div class="d-lg-flex row d-xl-none align-items-center">
            <div class="col-md-12 align-items-center">
                <div class="d-flex justify-content-center">
                    <a href="https://www.facebook.com/Convergenzespa" class="facebook-link text-right" target="_blank">
                        <ficon :icon="['fab', 'facebook-f']" size="2x"></ficon>
                        
                    </a>
                    <a href="https://twitter.com/ConvergenzeSPA" class="twitter-link" target="_blank">
                        <ficon :icon="['fab', 'twitter']" size="2x"></ficon>
                    </a>
                    <a href="https://www.instagram.com/convergenze.it/" class="instagram-link" target="_blank">
                        <ficon :icon="['fab', 'instagram']" size="2x"></ficon>
                    </a>
                    
                    <a href="https://www.linkedin.com/company/convergenze---s.p.a." class="linkedin-link"
                        target="_blank">
                        <ficon :icon="['fab', 'linkedin-in']" size="2x"></ficon>
                    </a>
                    <a href="https://www.youtube.com/channel/UC0vUWxtZgfyrQMwi9FnEuyA" class="youtube-link"
                        target="_blank">
                        <ficon :icon="['fab', 'youtube']" size="2x"></ficon>
                    </a>
                </div>
            </div>
            
            <div class="col-md-12 text-center pt-2">            
                <router-link to="/" class="navbar-brand">
                    &nbsp;&nbsp;<img src="../assets/images/logo_sm.png" class="img-fluid" />
                </router-link>
            </div>
            <div class="col-md-12 text-center pt-2">
                <div class="text-center text-white">
                    <h2>800 987 787 </h2>
                </div>
            </div>
        </div>
</div>  
</template>

<script>

///import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'MainFooter',
  data: function() {
    return  {
      
    };
  },
  props: {    
  },
  methods: {    
  },
  computed: {    
  }
}
</script>
